import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useSeo } from "@/hooks/useSeo";
import ContactForm from "./components/ContactForm";

const contactItems = [
  {
    icon: "ri-mail-line",
    label: "电子邮箱",
    value: "service@hongtao.com",
    note: "内容合作、意见反馈",
  },
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "010-8888-6666",
    note: "周一至周五 9:00 - 18:00",
  },
  {
    icon: "ri-map-pin-line",
    label: "公司地址",
    value: "北京市朝阳区建国路 88 号 红桃媒体中心 12 层",
    note: "欢迎预约到访",
  },
];

export default function ContactPage() {
  useSeo({
    title: "联系我们 - 红桃网",
    description:
      "通过邮箱、电话或在线留言联系红桃网。无论是内容合作、意见反馈还是投稿建议，我们都期待听到你的声音。",
    keywords: "联系红桃网,联系方式,在线留言,意见反馈",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <div className="w-full bg-background-100 border-b border-background-200">
          <div className="w-full px-4 md:px-8 py-6 md:py-8">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "联系我们" }]} />
            <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-5">
              联系我们
            </h1>
            <p className="text-sm text-foreground-600 mt-2 max-w-2xl leading-relaxed">
              欢迎通过以下方式与我们取得联系，也欢迎在页面右侧留下你的宝贵意见。
            </p>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 py-8 md:py-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* 左：联系方式 + 地图 */}
            <div className="space-y-5">
              <div className="space-y-4">
                {contactItems.map((item) => (
                  <div
                    key={item.label}
                    className="flex items-start gap-4 rounded-xl bg-background-100 border border-background-200 p-5"
                  >
                    <span className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-xl text-primary-600`} />
                    </span>
                    <div className="min-w-0">
                      <p className="text-xs text-foreground-400 mb-0.5">
                        {item.label}
                      </p>
                      <p className="text-sm md:text-base font-semibold text-foreground-900 break-words">
                        {item.value}
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">
                        {item.note}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="rounded-xl overflow-hidden border border-background-200 h-[240px] md:h-[280px]">
                <iframe
                  title="红桃网办公地点地图"
                  src="https://tbbl.com.cn/maps?q=Beijing%20Chaoyang%20Jianguo%20Road&output=embed"
                  className="w-full h-full"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            {/* 右：留言表单 */}
            <ContactForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}